import { useId } from "react";

import { Field, errorInputStyle, inputStyle } from "./Field";

export interface SelectOption {
  value: string;
  label: string;
}

interface SelectFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: ReadonlyArray<SelectOption>;
  required?: boolean;
  helper?: React.ReactNode;
  error?: string | null;
  placeholder?: string;
  disabled?: boolean;
}

export function SelectField({
  label,
  value,
  onChange,
  options,
  required,
  helper,
  error,
  placeholder,
  disabled,
}: SelectFieldProps) {
  const id = useId();
  return (
    <Field label={label} htmlFor={id} required={required} helper={helper} error={error}>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        disabled={disabled}
        style={error ? errorInputStyle : inputStyle}
      >
        {placeholder !== undefined && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </Field>
  );
}
